import { VenueFormValuesType } from '@common';
import { TagsInput, TagsInputProps } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';

type TagsInputFieldPropsType = TagsInputProps;

export const TagsInputField: React.FC<TagsInputFieldPropsType> = (props) => {
  const { control } = useFormContext<VenueFormValuesType>();

  return (
    <Controller
      control={control}
      name="venuePromoterId"
      render={({ field }) => <TagsInput {...field} {...props} />}
    />
  );
};
